import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TitleH2 } from "../../../../../../../../../../../../Components/CustomUi/titleH2"
import { ContainerPontos, ModalCopiaAnalises } from "../../styled"
import { faClose, faFloppyDisk, faSquare } from "@fortawesome/free-solid-svg-icons"
import { Select } from "../../../../../../../../../../../../Components/CustomUi/Select"
import { useState } from "react"
import { Box } from "../../../../../../../../../../../../Components/CustomUi/box"
import { GeoPointFeature } from "../../../headerAnalises/components/modalNovaAnalise"
import { LabAnaliseItens } from "../../../../../../../../../../../../services/LabAnalise"
import ButtonCustom from "../../../../../../../../../../../../Components/ButtonCustom"
import { warningAlert } from "../../../../../../../../../../../../utils/alert"

interface PropsModalCopiarAnalises {
    abrirModalCopia: boolean
    setAbrirModalCopia: Function
    pontos_selecionados: GeoPointFeature[]
    grupoAnalises: LabAnaliseItens[]
    analises: any[]
    setAnalises: React.Dispatch<React.SetStateAction<any[]>>
}

export const ModalCopiarAnalises: React.FC<PropsModalCopiarAnalises> = ({
    abrirModalCopia,
    setAbrirModalCopia,
    pontos_selecionados,
    grupoAnalises,
    analises,
    setAnalises,
}) => {
    const [openSelect, setOpenSelect] = useState<boolean>(false)
    const [analiseSelecionada, setAnaliseSelecionada] = useState<string>('')
    const [analiseSelecionadaId, setAnaliseSelecionadaId] = useState<number | null>(null)
    const [cor_selecionada, setCor_selecionada] = useState<string>('')

    const grupoAnalisesTratado = grupoAnalises?.map((item) => ({
        ...item,
        analise_profundidade_nome: `(${item?.profundidade_nome}) | ${item?.analise_nome}`,
    }))

    function selectCor(cod) {
        setAnaliseSelecionadaId(cod)
        const filter = grupoAnalisesTratado?.filter((item) => item?.cod_analise === cod)
        setCor_selecionada(filter[0]?.cor)
    }

    function fechar() {
        setAnaliseSelecionada('')
        setAnaliseSelecionadaId(null)
        setOpenSelect(false)
        setAbrirModalCopia(false)
    }

    function salvarCopia() {
        if (!analiseSelecionadaId) {
            return warningAlert('Selecione um tipo de análise antes de salvar.')
        }

        const analiseOrigem = grupoAnalises?.find((item) => item?.cod_analise === analiseSelecionadaId)

        if (!analiseOrigem) {
            return warningAlert('Análise não encontrada.')
        }

        // Verifica se já existe uma análise com esse cod_analise
        const jaExiste = analises.some((a) => a?.cod_analise === analiseSelecionadaId)
        if (jaExiste) {
            return warningAlert('Já existe uma análise com esse tipo cadastrada.')
        }

        const novosPontos = pontos_selecionados.map((p) => ({
            ...p,
            COR: analiseOrigem?.cor || p.COR,
        }))

        const valorUnitario = Number(analiseOrigem?.valor) || 0

        const novaAnalise = {
            id: Date.now(),
            cod_analise: analiseSelecionadaId,
            pontos_selecionados: novosPontos,
            profundidade: analiseOrigem?.profundidade_nome,
            analise_nome: analiseOrigem?.analise_nome,
            valor: analiseOrigem?.valor,
            cor: analiseOrigem?.cor,
            valor_analise: (valorUnitario * novosPontos.length).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
            }),
        }

        setAnalises((prev) => [...prev, novaAnalise])
        fechar()
    }

    return (
        <ModalCopiaAnalises
            open={abrirModalCopia}
            onCancel={fechar}
            title=''
            closeIcon={false}
            footer={false}
        >
            <div className='titulo__modal'>
                <TitleH2>Copiar análise</TitleH2>
                <FontAwesomeIcon icon={faClose} onClick={fechar} style={{ cursor: 'pointer' }} />
            </div>
            <div className="body__modal">
                <Select
                    label="Tipo de análise"
                    placeholder="Selecione o tipo de análise"
                    value={analiseSelecionada}
                    icon={faSquare}
                    onChange={setAnaliseSelecionada}
                    onChangeID={(id) => selectCor(id)}
                    open={openSelect}
                    trigger={setOpenSelect}
                    items={grupoAnalisesTratado || []}
                    descricaoItem="analise_profundidade_nome"
                    idItem="cod_analise"
                    cor={cor_selecionada}
                    extraItem={'cor'}
                />
                <Box style={{ marginTop: '10px' }}>
                    <ContainerPontos>
                        <h3 className='points-title'>Pontos ({pontos_selecionados?.length || 0})</h3>
                        <div className='points-grid'>
                            {pontos_selecionados?.map((point, index) => (
                                <div
                                    key={index}
                                    className='point-card'
                                    style={{ backgroundColor: point?.COR || '#ccc' }}
                                >
                                    {point?.NOME?.toString().padStart(2, '0')}{' '}
                                </div>
                            ))}
                        </div>
                    </ContainerPontos>
                </Box>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                    <ButtonCustom
                        onClick={salvarCopia}
                        icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                    >
                        Copiar
                    </ButtonCustom>
                </div>
            </div>
        </ModalCopiaAnalises>
    )
}
